import { useEffect, useState } from "react";
import { MapPin } from "lucide-react";
import { api } from "@/lib/api";
import { Reveal, ImageReveal } from "@/components/Reveal";
import EditorialMarquee from "@/components/EditorialMarquee";

export default function Artists() {
  const [artists, setArtists] = useState([]);

  useEffect(() => {
    api.get("/artists").then((r) => setArtists(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="artists-page" className="min-h-screen bg-white pt-20">
      <section className="mx-auto max-w-[1500px] px-5 md:px-10 pt-16 md:pt-24">
        <Reveal>
          <p className="font-mono-hw text-[12px] uppercase tracking-[0.3em] text-gavra">The Roster</p>
          <h1 className="mt-4 max-w-4xl font-heading text-5xl font-black uppercase leading-[0.85] tracking-tighter md:text-8xl">
            Drummers Who<br />Trust GAVRA
          </h1>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-black/60 md:text-lg">
            Hand-picked players who push their kits to the limit. These are the artists who put our
            hardware through hell — and keep coming back.
          </p>
        </Reveal>
      </section>

      <section className="mx-auto max-w-[1500px] px-5 md:px-10 py-16 md:py-24">
        <div className="grid grid-cols-1 gap-x-6 gap-y-16 md:grid-cols-2 lg:grid-cols-3">
          {artists.map((a, i) => (
            <ImageReveal key={a.id}>
              <article data-testid={`artist-card-${i}`} className="group">
                <div className={`relative overflow-hidden border border-black/10 ${i % 2 === 0 ? "aspect-[3/4]" : "aspect-[4/5] md:mt-12"}`}>
                  <img
                    src={a.image_url}
                    alt={a.name}
                    className="h-full w-full object-cover grayscale transition-all duration-700 ease-out group-hover:grayscale-0 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 flex items-end bg-gradient-to-t from-gavra/90 via-transparent to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                    <div className="p-6">
                      <p className="font-heading text-2xl font-black uppercase text-white">{a.name}</p>
                    </div>
                  </div>
                </div>
                <div className="mt-5">
                  <div className="flex items-center justify-between">
                    <h3 className="font-heading text-2xl font-bold uppercase tracking-tight">{a.name}</h3>
                  </div>
                  <p className="mt-1 font-mono-hw text-[11px] uppercase tracking-widest text-gavra">{a.role}</p>
                  {a.location && (
                    <p className="mt-2 flex items-center gap-1.5 text-xs text-black/40">
                      <MapPin className="h-3.5 w-3.5" /> {a.location}
                    </p>
                  )}
                  <p className="mt-4 text-sm leading-relaxed text-black/60">{a.bio}</p>
                  {a.setup?.length > 0 && (
                    <div className="mt-5 border-t border-black/10 pt-4">
                      <p className="font-mono-hw text-[10px] uppercase tracking-widest text-black/40">Rig</p>
                      <ul className="mt-2 flex flex-wrap gap-2">
                        {a.setup.map((s, si) => (
                          <li key={si} className="border border-black/15 px-2.5 py-1 text-[11px] font-medium">{s}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </article>
            </ImageReveal>
          ))}
        </div>
      </section>

      <EditorialMarquee text={["No Compromise", "Hit Hard", "Stay Locked In"]} speed={45} dark />
    </div>
  );
}
